import React, { useEffect, useState } from "react";
import { object } from "prop-types";

import { Dropdown } from "../../atoms/Dropdown";
import MagazineEditions from "../../../arrow/components/Rows/MagazineEditions";
import { STATIC_KEYWORDS } from "../../../constants";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { trackLoadMoreClick } from "../../utils";
import LoadingIndicatorComponent from "../../atoms/loading-indicator";

import "./all-magazines-listing-page.m.css";
import CircleIcon from "../../atoms/Circle";

export const AllMagazinesListingPage = ({ data }) => {
  const [collection, setCollection] = useState(data.data);
  const [loading, setLoading] = useState(false);
  const config = {
    showRowTitle: false,
    showBottomReadMore: true,
    showTitleReadMore: false,
  };
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const limit = typeof window === "undefined" ? collection.length : isDesktop ? 15 : 12;
  const [currentLimit, setCurrentLimit] = useState(limit);
  const { LOAD_MORE, OPEN_MAGAZINE, NO_MAGAZINE_ISSUES_FOUND } = STATIC_KEYWORDS;

  useEffect(() => setCurrentLimit(isDesktop ? 15 : 12), [deviceType]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "magazine",
      sub_category: "NA",
      content_id: "NA",
      template_name: "listing",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  return (
    <div className="container" styleName="magazines-listing-page">
      <div styleName="collection-title-container">
        <h1 styleName="collection-title">
          {isDesktop && <CircleIcon width="24" height="24" />}
          {OPEN_MAGAZINE}
        </h1>
        <Dropdown collection={collection} onSelect={setCollection} setLoading={setLoading} />
      </div>
      {collection.length > 0 ? (
        <div styleName="magazine-editions-container">
          <MagazineEditions
            collection={collection}
            config={config}
            limit={currentLimit}
            isStoryPage={false}
            pageType="all-magazines-listing-page"
          />
        </div>
      ) : (
        <div styleName="no-magazine">{NO_MAGAZINE_ISSUES_FOUND}</div>
      )}
      {currentLimit < collection.length && (
        <div styleName="load-more-button">
          <button
            onClick={() => {
              setCurrentLimit((prevLimit) => prevLimit + limit);
              trackLoadMoreClick({
                linkCategory: "magazine",
                category: "magazine",
                subCategory: "NA",
                templateName: "listing",
              });
            }}
          >
            {LOAD_MORE}
          </button>
        </div>
      )}
      <LoadingIndicatorComponent loading={loading} />
    </div>
  );
};

AllMagazinesListingPage.propTypes = {
  data: object,
};
